// extracted by mini-css-extract-plugin
module.exports = {"ResponsiveWrapper":"ResponsiveWrapper_ResponsiveWrapper__1cie4","Loading":"ResponsiveWrapper_Loading__128lf"};